<vdr-data-table-2
  id="baseProductVariants"
  [items]="items$ | async"
  [itemsPerPage]="itemsPerPage$ | async"
  [totalItems]="totalItems$ | async"
  [currentPage]="currentPage$ | async"
  (pageChange)="setPageNumber($event)"
  (itemsPerPageChange)="setItemsPerPage($event)"
>
  <vdr-dt2-column
    [heading]="'common.image' | translate"
    id="image"
  >
    <ng-template let-variant="item">
      <div class="image-placeholder">
        <img
          *ngIf="variant.featuredAsset as asset; else imagePlaceholder"
          [src]="asset | assetPreview: 'tiny'"
        />
        <ng-template #imagePlaceholder>
          <div class="placeholder">
            <clr-icon
              shape="image"
              size="48"
            ></clr-icon>
          </div>
        </ng-template>
      </div>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    id="seller"
    [heading]="'common.seller' | translate"
  >
    <ng-template let-variant="item">
      <a
        class="button-ghost"
        [routerLink]="[
          '/',
          'settings',
          'sellers',
          getSeller(variant.channels).seller.id
        ]"
      >
        <span>
          {{ getSeller(variant.channels).seller.name }}
        </span>
        <clr-icon shape="arrow right"></clr-icon>
      </a>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    id="variant"
    [heading]="'catalog.variant' | translate"
  >
    <ng-template let-variant="item">
      <a
        class="button-ghost"
        [routerLink]="[
          '/',
          'catalog',
          'products',
          variant.product.id,
          'variants',
          variant.id
        ]"
      >
        <span>
          {{ variant.name }}
        </span>
        <clr-icon shape="arrow right"></clr-icon>
      </a>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    id="product"
    [heading]="'catalog.product' | translate"
  >
    <ng-template let-variant="item">
      <a
        class="button-ghost"
        [routerLink]="['/', 'catalog', 'products', variant.product.id]"
        queryParamsHandling="preserve"
      >
        <span>
          {{ variant.product.name }}
        </span>
        <clr-icon shape="arrow right"></clr-icon>
      </a>
    </ng-template>
  </vdr-dt2-column>
</vdr-data-table-2>
